import React, { useState, useEffect } from 'react';
import api from '../utils/api';

const DEFAULT_COURT = 'Арбитражный суд Республики Башкортостан';
const emptyForm = () => ({ court: DEFAULT_COURT, name: '', room: '', phone: '', note: '', staff: [
  { role: 'Помощник', name: '', phone: '', room: '' },
  { role: 'Секретарь', name: '', phone: '', room: '' },
] });

const telHref = phone => 'tel:' + String(phone).split(/доб/i)[0].replace(/[^\d+]/g, '');

function Phone({ value }) {
  if (!value) return null;
  return <a href={telHref(value)} onClick={e => e.stopPropagation()} style={{ color: 'var(--accent)', whiteSpace: 'nowrap' }}>{value}</a>;
}

export default function JudgesPage() {
  const [judges, setJudges] = useState([]);
  const [q, setQ] = useState('');
  const [form, setForm] = useState(null); // null — форма закрыта; {id?...} — добавление/правка

  const load = () => api.get('/judges').then(r => setJudges(r.data));
  useEffect(() => { load(); }, []);

  const save = async () => {
    if (!form.name.trim()) return alert('Укажите ФИО судьи');
    if (form.id) await api.put(`/judges/${form.id}`, form); else await api.post('/judges', form);
    setForm(null); load();
  };
  const remove = async j => {
    if (!window.confirm(`Удалить судью ${j.name}?`)) return;
    await api.delete(`/judges/${j.id}`); load();
  };
  const setStaff = (i, key, val) => setForm(f => ({ ...f, staff: f.staff.map((s, k) => k === i ? { ...s, [key]: val } : s) }));

  const needle = q.trim().toLowerCase();
  const list = judges.filter(j => !needle || [j.name, j.court, j.room, j.phone, j.note, ...(j.staff || []).flatMap(s => [s.name, s.phone])]
    .some(v => v && String(v).toLowerCase().includes(needle)));

  return (
    <div>
      <div className="page-header" style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
        <h1 className="page-title">Судьи</h1>
        {!form && <button className="btn btn-primary" onClick={() => setForm(emptyForm())}>+ Добавить судью</button>}
      </div>

      {form && (
        <div className="card" style={{ marginBottom: 16 }}>
          <h3 style={{ fontSize: 15, fontWeight: 600, marginBottom: 12 }}>{form.id ? 'Редактирование' : 'Новый судья'}</h3>
          <div className="form-row">
            <div className="form-group" style={{ flex: 2 }}><label>ФИО судьи</label><input className="form-input" value={form.name} onChange={e => setForm({ ...form, name: e.target.value })} autoFocus /></div>
            <div className="form-group" style={{ flex: 2 }}><label>Суд</label><input className="form-input" value={form.court} onChange={e => setForm({ ...form, court: e.target.value })} /></div>
          </div>
          <div className="form-row">
            <div className="form-group"><label>Кабинет судьи</label><input className="form-input" value={form.room || ''} onChange={e => setForm({ ...form, room: e.target.value })} /></div>
            <div className="form-group"><label>Телефон судьи</label><input className="form-input" value={form.phone || ''} onChange={e => setForm({ ...form, phone: e.target.value })} /></div>
          </div>
          <div style={{ fontSize: 13, fontWeight: 600, margin: '8px 0' }}>Аппарат судьи</div>
          {form.staff.map((s, i) => (
            <div className="form-row" key={i} style={{ alignItems: 'flex-end' }}>
              <div className="form-group" style={{ flex: 1 }}><label>Должность</label><input className="form-input" value={s.role} onChange={e => setStaff(i, 'role', e.target.value)} list="judge-roles" /></div>
              <div className="form-group" style={{ flex: 2 }}><label>ФИО</label><input className="form-input" value={s.name} onChange={e => setStaff(i, 'name', e.target.value)} /></div>
              <div className="form-group" style={{ flex: 2 }}><label>Телефон</label><input className="form-input" value={s.phone} onChange={e => setStaff(i, 'phone', e.target.value)} placeholder="+7 (347) 222-92-07 доб. 354" /></div>
              <div className="form-group" style={{ flex: 1 }}><label>Кабинет</label><input className="form-input" value={s.room} onChange={e => setStaff(i, 'room', e.target.value)} /></div>
              <button className="btn btn-secondary btn-sm" style={{ marginBottom: 16 }} onClick={() => setForm(f => ({ ...f, staff: f.staff.filter((_, k) => k !== i) }))}>✕</button>
            </div>
          ))}
          <datalist id="judge-roles"><option value="Помощник" /><option value="Секретарь" /><option value="Секретарь судебного заседания" /></datalist>
          <button className="btn btn-secondary btn-sm" onClick={() => setForm(f => ({ ...f, staff: [...f.staff, { role: '', name: '', phone: '', room: '' }] }))}>+ сотрудник</button>
          <div className="form-group" style={{ marginTop: 12 }}><label>Заметки</label><textarea className="form-input" rows={3} value={form.note || ''} onChange={e => setForm({ ...form, note: e.target.value })} placeholder="Особенности судьи, как лучше дозвониться и т.п." /></div>
          <div style={{ display: 'flex', gap: 8 }}>
            <button className="btn btn-primary" onClick={save}>Сохранить</button>
            <button className="btn btn-secondary" onClick={() => setForm(null)}>Отмена</button>
          </div>
        </div>
      )}

      <input className="form-input" placeholder="Поиск по ФИО, телефону, суду…" value={q} onChange={e => setQ(e.target.value)} style={{ marginBottom: 16, maxWidth: 400 }} />

      {list.map(j => (
        <div className="card" key={j.id} style={{ marginBottom: 12 }}>
          <div style={{ display: 'flex', justifyContent: 'space-between', gap: 12, flexWrap: 'wrap' }}>
            <div>
              <div style={{ fontSize: 16, fontWeight: 700 }}>{j.name}</div>
              <div style={{ fontSize: 12, color: 'var(--text-muted)' }}>{j.court}</div>
              {(j.room || j.phone) && <div style={{ fontSize: 13, marginTop: 4 }}>{j.room && <>каб. {j.room}</>}{j.room && j.phone && ' · '}<Phone value={j.phone} /></div>}
            </div>
            <div style={{ display: 'flex', gap: 6, alignItems: 'flex-start' }}>
              <button className="btn btn-secondary btn-sm" onClick={() => { setForm({ ...j, staff: (j.staff || []).map(s => ({ ...s })) }); window.scrollTo(0, 0); }}>Изменить</button>
              <button className="btn btn-secondary btn-sm" onClick={() => remove(j)}>Удалить</button>
            </div>
          </div>
          {(j.staff || []).length > 0 && (
            <div className="table-wrap" style={{ marginTop: 10 }}><table><tbody>
              {j.staff.map((s, i) => (
                <tr key={i}>
                  <td style={{ color: 'var(--text-secondary)', width: 120 }}>{s.role}</td>
                  <td><strong>{s.name}</strong></td>
                  <td><Phone value={s.phone} /></td>
                  <td style={{ color: 'var(--text-muted)' }}>{s.room ? `каб. ${s.room}` : ''}</td>
                </tr>
              ))}
            </tbody></table></div>
          )}
          {j.note && <div style={{ fontSize: 13, marginTop: 8, whiteSpace: 'pre-wrap', color: 'var(--text-secondary)' }}>{j.note}</div>}
        </div>
      ))}
      {!list.length && <div className="empty-state"><p>{judges.length ? 'Ничего не найдено' : 'Судей пока нет'}</p></div>}
    </div>
  );
}
